import React, {useEffect, useRef} from 'react';
import css from './sticky.module.scss';

export function Sticky({ className, ...props }) {
  const ref = useRef();
  useEffect(() => {
    requestAnimationFrame(() => {
      const container = ref.current.closest('.sticky-container');
      ref.current.style.top = container?.getBoundingClientRect().top + 'px';
    });
  }, []);
  return (
    <div ref={ref} {...props} className={css('sticky', className, 'popup-container')} />
  );
}
